var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBounceTracking = function SvgBounceTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6E6E6E",
    fillRule: "evenodd",
    d: "M11 2.808H1V11h1.75a.5.5 0 0 1 0-1h3.105A4.51 4.51 0 0 0 2.25 7.045a4.49 4.49 0 0 1 4.014 1.478A7.43 7.43 0 0 1 8.219 4.73l.21.21L7.49 4h2.252v2.252l-.726-.726A6.3 6.3 0 0 0 7.266 10H9.25a.5.5 0 0 1 0 1H11zm0-1H1V1h10zm1 0V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1.808M1.846 1.385a.23.23 0 1 1-.461 0 .23.23 0 0 1 .461 0m.692.23a.23.23 0 1 0 0-.461.23.23 0 0 0 0 .461m1.154-.23a.23.23 0 1 1-.461 0 .23.23 0 0 1 .461 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgBounceTracking;